import { Routes } from '@angular/router';
import { pathsMatcher } from './url-matcher.util';

/**
 * Lazy-loaded feature modules. Paths match existing feature routing modules
 * so URLs and behavior stay the same — only the load strategy changes.
 */
export const FEATURE_LAZY_ROUTES: Routes = [
  {
    matcher: pathsMatcher([
      'messDetails', 'messInventory', 'messDetailsInventory', 'messDoDetails',
      'messDoDetailsView', 'messClosedDetails', 'messExcelDetails', 'mealRequest',
      'mealOrderSummary', 'adminDashboardReports', 'adminDivisionReport',
      'addNewMenuItem', 'adminMessInventory',
    ]),
    loadChildren: () =>
      import('../../modules/mess-details/mess-details.module').then((m) => m.MessDetailsModule),
  },
  {
    matcher: pathsMatcher(['merakiDashboard']),
    loadChildren: () =>
      import('../../modules/wifi/wifi.module').then((m) => m.WifiModule),
  },
  {
    matcher: pathsMatcher(['Attendance']),
    loadChildren: () =>
      import('../../modules/attendance/attendance.module').then((m) => m.AttendanceModule),
  },
  {
    matcher: pathsMatcher(['courseMaster', 'campus-Track', 'course-Track']),
    loadChildren: () =>
      import('../../modules/course-Master/course-master.module').then((m) => m.CourseMasterModule),
  },
  {
    matcher: pathsMatcher(['studentcounsellingdashboard']),
    loadChildren: () =>
      import('../../modules/Student-Counselling-dashboard/counselling-dashboard.module').then(
        (m) => m.CounsellingDashboardModule
      ),
  },
  {
    matcher: pathsMatcher(['assetQREntry']),
    loadChildren: () =>
      import('../../modules/assests tracting/assests.module').then((m) => m.AssestsModule),
  },
  {
    matcher: pathsMatcher(['counselling']),
    loadChildren: () =>
      import('../../modules/counselling/counselling.module').then((m) => m.CounsellingModule),
  },
  {
    matcher: pathsMatcher(['ReceiptCancellationApproval']),
    loadChildren: () =>
      import('../../modules/ReceiptCancellation/receipt-cancellation.module').then(
        (m) => m.ReceiptCancellationModule
      ),
  },
  {
    matcher: pathsMatcher(['IpeMarks']),
    loadChildren: () =>
      import('../../modules/IPEMARKES/ipemarkes.module').then((m) => m.IpemarkesModule),
  },
  {
    matcher: pathsMatcher(['vehicleQREntry']),
    loadChildren: () =>
      import('../../modules/asset-vehicle-entry/assetvehicle.module').then((m) => m.AssetvehicleModule),
  },
  {
    matcher: pathsMatcher(['assetQRApproval']),
    loadChildren: () =>
      import('../../modules/Asset-QR-Approval/assetqrapproval.module').then((m) => m.AssetqrapprovalModule),
  },
  {
    matcher: pathsMatcher(['printBuildingAssetQRDetail']),
    loadChildren: () =>
      import('../../modules/print-Asset-QR/print-assets-qr.module').then((m) => m.PrintAssetsQRModule),
  },
  {
    matcher: pathsMatcher(['printBulkBuildingAssetQRDetail']),
    loadChildren: () =>
      import('../../modules/print-Bulk-assetQR-Details/bulk-asset.module').then((m) => m.BulkAssetModule),
  },
  {
    matcher: pathsMatcher(['assetTransferEntry', 'assetTransferList']),
    loadChildren: () =>
      import('../../modules/Asset-Transfer-Entry/asset-transfer-entry.module').then(
        (m) => m.AssetTransferEntryModule
      ),
  },
  {
    matcher: pathsMatcher(['assetTransferApprovaList']),
    loadChildren: () =>
      import('../../modules/asset-transfer-approve/asset-transfer-approve.module').then(
        (m) => m.AssetTransferApproveModule
      ),
  },
  {
    matcher: pathsMatcher(['vehicleQRApproval']),
    loadChildren: () =>
      import('../../modules/asset-vehicle-approval/asset-vehicle-approval.module').then(
        (m) => m.AssetVehicleApprovalModule
      ),
  },
  {
    matcher: pathsMatcher(['printBuildingVehicleQRDetail']),
    loadChildren: () =>
      import('../../modules/print-assetvehicle-QR/print-vehicle-qr.module').then(
        (m) => m.PrintVehicleQrModule
      ),
  },
  {
    matcher: pathsMatcher(['printBulkBuildingVehicleQRDetail']),
    loadChildren: () =>
      import('../../modules/print-Bulk-assetVehicleQR-Details/print-bulk-vehicle.module').then(
        (m) => m.PrintBulkVehicleModule
      ),
  },
  {
    matcher: pathsMatcher(['studentHTNoVerification']),
    loadChildren: () =>
      import('../../modules/Student  Verification/student-verification.module').then(
        (m) => m.StudentVerificationModule
      ),
  },
  {
    matcher: pathsMatcher(['migration']),
    loadChildren: () =>
      import('../../modules/student-migration-form/student-migration.module').then(
        (m) => m.StudentMigrationModule
      ),
  },
  {
    matcher: pathsMatcher(['Notification']),
    loadChildren: () =>
      import('../../modules/Sms  Push Notification/push-notification.module').then(
        (m) => m.PushNotificationModule
      ),
  },
  {
    matcher: pathsMatcher(['log_tracking']),
    loadChildren: () =>
      import('../../modules/Log-Tracking/logtracking.module').then((m) => m.LogtrackingModule),
  },
  {
    matcher: pathsMatcher([
      'grievanceDashboard', 'studentGrievanceDashboard', 'ticketDetails',
      'grievanceReport', 'employeeGrievanceApplication', 'grievanceuser2','trackDetailsAdmin',
      'trackDetailsuser2', 'grievanceAdmin', 'grievanceSuperadmin', 'trackDetailsSuperadmin',
    ]),
    loadChildren: () =>
      import('../../modules/Grievance-Dashboard/grievance-dashboard.module').then(
        (m) => m.GrievanceDashboardModule
      ),
  },
  {
    matcher: pathsMatcher(['scoreRegistration','scoreReports']),
    loadChildren: () =>
      import('../../modules/Score-Registration/score-registration.module').then(
        (m) => m.ScoreRegistrationModule
      ),
  },
   {
    matcher: pathsMatcher(['progressReport']),
    loadChildren: () =>
      import('../../modules/parent-App/parent-app.module').then(
        (m) => m.ParentAppModule
      ),
  },
  {
    matcher: pathsMatcher(['studentCounsellingExcelReport']),
    loadChildren: () =>
      import('../../modules/student counselling Report/student-counselling-report.module').then(
        (m) => m.StudentCounsellingReportModule
      ),
  },
  {
    matcher: pathsMatcher(['gmDashboard']),
    loadChildren: () =>
      import('../../modules/Gm-Dashboard/gm-dashboard.module').then((m) => m.GmDashboardModule),
  },
  {
    matcher: pathsMatcher(['hygine']),
    loadChildren: () =>
      import('../../modules/Hygiene Report/hygiene-report.module').then((m) => m.HygieneReportModule),
  },
  {
    matcher: pathsMatcher(['outingDashboard']),
    loadChildren: () =>
      import('../../modules/outing-approval/outing-approval.module').then((m) => m.OutingApprovalModule),
  },
  {
    matcher: pathsMatcher(['userdashboard']),
    loadChildren: () =>
      import('../../modules/surveillance/surveillances.module').then((m) => m.SurveillancesModule),
  },
  {
    matcher: pathsMatcher(['studentCounsellingdetailesReport']),
    loadChildren: () =>
      import('../../modules/student counselling details/student-counselling-detials-report.module').then(
        (m) => m.StudentCounsellingDetialsReportModule
      ),
  },
  {
    matcher: pathsMatcher(['HrmsReport', 'hrmssubject', 'costcenter', 'deptdesign', 'employeeexit']),
    loadChildren: () =>
      import('../../modules/hrms-reports/hrms-reports.module').then((m) => m.HrmsReportsModule),
  },
  {
    matcher: pathsMatcher(['jee', 'jee2', 'rookie', 'rookie2', 'neet', 'neetRookie']),
    loadChildren: () =>
      import('../../modules/HallTicketEntry/jee-mains-session1-entry.module').then(
        (m) => m.JeeMainsSession1EntryModule
      ),
  },
  {
    matcher: pathsMatcher(['facultyTrackingDashboard', 'campusGooglemap']),
    loadChildren: () =>
      import('../../modules/faculty-tracking-dashbaord/faculty-tracking-dashbaord.module').then(
        (m) => m.FacultyTrackingDashbaordModule
      ),
  },

   // Prefixed lazy modules (existing pattern)
   
  {
    path: 'facultyTracking',
    loadChildren: () =>
      import('../../modules/faculty-tracking/faculty-tracking.module').then(
        (m) => m.FacultyTrackingModule
      ),
  },
  {
    matcher: pathsMatcher(['hrDetails']),
    loadChildren: () => import('../../hr/hr.module').then((m) => m.HrModule),
  },
  {
    matcher: pathsMatcher(['BuildingData']),
    loadChildren: () =>
      import('../../modules/building-Image/building-images.module').then((m) => m.BuildingImagesModule),
  },
  {
    matcher: pathsMatcher([
      'building-image-data', 'hygieneStaffAttendance', 'hygiene-day-wise-report',
      'hygine-cleaning', 'house-keeping-command-centre', 'housekeeping-dashboard',
      'housekeeping-dashboard-tv', 'ticketingStaffAttendance', 'no-access',
    ]),
    loadChildren: () =>
      import('../../modules/Hygine-Staft-report/hygiene-staft-report.module').then(
        (m) => m.HygieneStaftReportModule
      ),
  },
  {
    matcher: pathsMatcher(['studentfeedback']),
    loadChildren: () =>
      import('../../modules/student -feedback/student-feedback.module').then(
        (m) => m.StudentFeedbackModule
      ),
  },
  {
    matcher: pathsMatcher(['JEEMainVerification']),
    loadChildren: () =>
      import('../../modules/jee-mains-hall-ticket-verification/jee-mains-hall-ticket-verification.module').then(
        (m) => m.JeeMainsHallTicketVerificationModule
      ),
  },
  {
    matcher: pathsMatcher(['selfAssessment']),
    loadChildren: () =>
      import('../../modules/Self-Assessment/self-assessment.module').then(
        (m) => m.SelfAssessmentModule
      ),
  },
  {
    matcher: pathsMatcher(['ScenarioAssessment']),
    loadChildren: () =>
      import('../../modules/Scenario-Assessment/scenario-assessment.module').then(
        (m) => m.ScenarioAssessmentModule
      ),
  },
  {
    matcher: pathsMatcher(['AcademicCounsel']),
    loadChildren: () =>
      import('../../modules/academic-form/academic-form.module').then(
        (m) => m.AcademicFormModule
      ),
  },
  {
    matcher: pathsMatcher(['studentwellbeing', 'studentwellbeingReport']),
    loadChildren: () =>
      import('../../modules/student-well-being/student-well-being/student-well-being.module').then(
        (m) => m.StudentWellBeingModule
      ),
  },
  {
    matcher: pathsMatcher(['StudentAttendances']),
    loadChildren: () =>
      import('../../modules/student_Attendances/student-attendance.module').then(
        (m) => m.StudentAttendanceModule
      ),
  },
  {
    path: 'score',
    loadChildren: () =>
      import('../../modules/score/score.module').then((m) => m.ScoreModule),
  },
  {
    path: 'appScaits',
    loadChildren: () =>
      import('../../modules/app-scaits/app-scaits.module').then((m) => m.AppScaitsModule),
  },
];
